import Common from '../Common';

const Login = class extends Common {
	async login(clientId?: string, username?: string, password?: string, tfa?: string) {
		return new Promise((resolve, reject) => {
			if(!clientId || !username || !password) {
				reject()
				return
			}

			this.postNoHeaders(
				"/oauth2/user-credentials",
				{
					grant_type: "password",
					client_id: clientId,
					username: username,
					password: password,
					tfa: tfa ?? "",
				}
			)
			.then(resolve)
			.catch(reject);
		})
	}

	refreshToken(clientId: string, refreshToken: string) {
		const body: any = {
			grant_type: "refresh_token",
			client_id: clientId,
			refresh_token: refreshToken,
		};

		return this.post('/oauth2/refresh-token', body);
	}

	async samlLogin(email?: string, clientId?: string, redirectURL = true) {
		return new Promise((resolve, reject) => {
			if(!email || !clientId) {
				reject()
				return
			}

			const d:{[key: string]: any} = { client_id: clientId };

			if(redirectURL) {
				d.redirect_url = window.location.href
			}

			this.postNoHeaders(
				`/saml/url/${encodeURIComponent(email)}`,
				d
			)
			.then(resolve)
			.catch(reject);
		})
	}

	async samlAuthed(email?: string, cookie?: string) {
		return new Promise((resolve, reject) => {
			if(!email || !cookie) {
				reject()
				return
			}

			this.get(`/saml/authed/${encodeURIComponent(email)}/${encodeURIComponent(cookie)}`)
			.then(resolve)
			.catch(reject);
		})
	}
}

export default Login
